export var GLOBAL={

   url: 'https://idcard.scmecobasa.com/api/',

   urlImaen: 'https://idcard.scmecobasa.com',
   urlEcobasa: 'https://scmecobasa.com/api/',

}
